import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';

import { useDeleteMemberNotificationMutation } from 'store/api/version-api.slice';

import { EMAIL_KEYMAP } from '../constants';

const EmailListItem = ({ item, IconComponent, onEditEmail, className }) => {
	const [deleteMemberNotification, { isLoading: isDeleteLoading }] = useDeleteMemberNotificationMutation();

	const onRemoveEmail = id => () => {
		deleteMemberNotification(id);
	};

	return (
		<ListItem sx={className}>
			{IconComponent && (
				<ListItemAvatar>
					<Avatar>
						<IconComponent />
					</Avatar>
				</ListItemAvatar>
			)}
			<ListItemText
				primary={EMAIL_KEYMAP[item.email_type]}
				secondary={item.email_subject}
				primaryTypographyProps={{ color: 'primary' }}
				secondaryTypographyProps={{ variant: 'caption' }}
			/>
			<ListItemSecondaryAction>
				{isDeleteLoading ? (
					<CircularProgress size={21} />
				) : (
					<>
						<IconButton edge="end" aria-label="delete" onClick={onEditEmail(item.id)}>
							<EditIcon />
						</IconButton>
						<IconButton edge="end" aria-label="delete" onClick={onRemoveEmail(item.id)}>
							<CloseIcon />
						</IconButton>
					</>
				)}
			</ListItemSecondaryAction>
		</ListItem>
	);
};

export default EmailListItem;
